import { render } from "./DueTicketsToday.vue?vue&type=template&id=195e5b0c&ts=true"
import script from "./DueTicketsToday.vue?vue&type=script&lang=ts"
export * from "./DueTicketsToday.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__